
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputCheckbox from '../../commons/form/InputCheckBox'
import InputText from '../../commons/form/InputText'
import { handleKeyDown } from '../../../util/utils'

class SignTypeModal extends PureComponent {
  submitSignType (values) {
    var signType = {}
    signType.signTypeId = this.props.signType.signTypeId
    signType.code = values.code
    signType.available = values.available

    this.props.actions.submitSignType(signType)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.signType)
    }
  }

  render () {
    const {
      t,
      showModal,
      handleSubmit
    } = this.props
    const tKey = 'MASTERS.SIGNATURE_TYPE_MASTERS.MODAL.'

    return (
      <Modal id="signTypeModal" show={showModal} onHide={this.props.actions.closeSignTypeModal} className="_nf">
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitSignType.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={80} // 25, 33, 50, 75, 100 default=25
                name={'code'}
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                maxLength={50}
                disabled={true}
              />
              <Field
                component={InputCheckbox}
                colWidth={20} // 25, 33, 50, 75, 100 default=25
                controlLabel={t(`${tKey}AVAILABLE`)}
                placeholder={t(`${tKey}AVAILABLE`)}
                name={'available'}
                id={'available'}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                type="submit"
                className="_Btn new"
                disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'signTypeModal'
})(SignTypeModal)
